import React, { createRef } from "react"

//Utils
import GoogleRecaptcha from "react-google-recaptcha"
import ico_wa from "assets/img/icon/ico_whatsapp.svg"
import ico_message from "assets/img/icon/ico_message.svg"

//Components
import { Button, Input } from "components/anti"
import { F_M_CONTACT_FORM, sendDataLayer } from "lib/function"
import { useDispatch } from "react-redux"
import { SET_TEXT_TOAST, SET_SHOW_TOAST, SET_TYPE_TOAST } from "lib/redux/types"
import { useRouter } from "next/router"
import * as Yup from "yup"
import { Formik } from "formik"

const Contact = () => {
  //States
  const recaptchaRef = createRef()
  const router = useRouter()
  const { locale } = router
  const dispatch = useDispatch()

  const [state, setState] = React.useState({
    name: "",
    email: "",
    message: "",
    topic: "",
    isDisable: true,
    keyCaptcha: null,
    isLoading: false,
    isSuccess: false,
    isVerify: false,
  })

  const initialState = {
    name: "",
    email: "",
    message: "",
    topic: "",
  }

  const YupValidation = Yup.object({
    name: Yup.string()
      .required(locale === "id" ? "Nama wajib diisi" : "Name required")
      .test("len", "Minimal 3 character alphabet", (val) => val?.length >= 3)
      .matches(
        /^[a-zA-Z\s]*$/,
        "Invalid Characters. Please use only alphabets to fill your name"
      ),
    email: Yup.string()
      .email(locale === "id" ? "Email tidak valid" : "Email not valid")
      .required(locale === "id" ? "Email wajib diisi" : "Email required"),
    message: Yup.string().required(
      locale === "id" ? "Pesan wajib diisi" : "Message required"
    ),
  })

  //Functions
  const handleChange = (e) =>
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }))

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setState((prev) => ({ ...prev, isLoading: true }))
    let { name, email, topic, message } = values

    try {
      let { data, errors } = await F_M_CONTACT_FORM({
        name,
        email,
        topic,
        message,
      })
      if (data) {
        setState((prev) => ({
          ...prev,
          isLoading: true,
          isSuccess: true,
        }))
        resetForm()
        dispatch({ type: SET_SHOW_TOAST, payload: true })
        dispatch({ type: SET_TYPE_TOAST, payload: "success" })
        dispatch({
          type: SET_TEXT_TOAST,
          payload: "Your message already sent!",
        })
        sendDataLayer({
          event: "contact_us",
          content_name: "Submit Form",
          section: "Contact Us",
        })
        window.scrollTo(0, 0)
        setTimeout(() => {
          dispatch({ type: SET_SHOW_TOAST, payload: false })
          window.location.reload()
        }, 3000)
      } else {
        setState((prev) => ({ ...prev, isLoading: false }))
      }
    } catch (error) {
      console.log(error)
    } finally {
      recaptchaRef.current.reset() //! Important: For Reset Captcha
    }
  }

  const handleVerify = (e) => {
    setState((prev) => ({ ...prev, isVerify: true, isDisable: false }))
  }

  //React Operations
  return (
    <section className="sc-contact">
      <div className="container mw-md">
        <div className="btn-back-wrapper">
          <span
            className="ail ai-arrow-left font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={() => router.back()}
          />
        </div>
        <h3 className="title-page">Contact Us</h3>
        <h6 className="subtitle-page">
          <span className="d-none d-md-inline">Contact us at</span>
          <span className="mx-2">
            <img src={ico_wa?.src} alt={"ico_wa"} className={"mr-1"} />
            <Button
              variant="link"
              className="hover-underline inverse pt-0"
              link="https://api.whatsapp.com/send?phone=6282210769566"
              target="__blank"
              onClick={() =>
                sendDataLayer({
                  event: "contact_us",
                  content_name: "whatsapp",
                  section: "Contact Us",
                })
              }
            >
              082210769566
            </Button>
            <span className="mx-2">/</span>
            <img
              src={ico_message?.src}
              alt={"ico_message"}
              className={"mr-1"}
            />
            <Button
              variant="link"
              className="hover-underline inverse pt-0"
              link="mailto:hello@nagarey.com"
              onClick={() =>
                sendDataLayer({
                  event: "contact_us",
                  content_name: "Email",
                  section: "Contact Us",
                })
              }
            >
              hello@nagarey.com
            </Button>
          </span>
          <br />
          <span>
            or use the contact form below and we'll try to reply you as soon as
            possible.
          </span>
        </h6>
        <div className="contact-us-form">
          <Formik
            initialValues={initialState}
            validationSchema={YupValidation}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, handleChange, touched, errors, values }) => (
              <form onSubmit={handleSubmit} noValidate>
                <div className="form-row form-row row-2">
                  <div className="form-group col-md-6">
                    <Input
                      label="Name"
                      name="name"
                      placeholder="Insert your name"
                      onChange={handleChange}
                      value={values.name}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <Input
                      label="Email"
                      name="email"
                      type="email"
                      placeholder="Insert your email address"
                      onChange={handleChange}
                      value={values.email}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div className="form-group col-12">
                    <Input
                      label="Subject (Optional)"
                      name="topic"
                      placeholder="Insert your subject"
                      onChange={handleChange}
                      value={values.topic}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div className="form-group col-12">
                    <Input
                      as="textarea"
                      name="message"
                      label="Message"
                      placeholder="Insert your message"
                      onChange={handleChange}
                      value={values.message}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                </div>
                <div className="recaptcha">
                  <GoogleRecaptcha
                    ref={recaptchaRef}
                    sitekey={process.env.DEV_CAPTCHA_SITE_KEY}
                    onChange={handleVerify}
                  />
                </div>
                <div className="d-flex flex-row-reverse mt-4">
                  <Button
                    disabled={state.isDisable}
                    className={`w-100 w-md-25 ${state.isLoading}`}
                    loader
                    // onClick={handleSubmit}
                    type="submit"
                  >
                    {!state.isSuccess ? (
                      "Submit"
                    ) : (
                      <i className="air ai-check"></i>
                    )}
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </section>
  )
}

// <GoogleRecaptcha
//    // theme={theme}
// sitekey={process.env.DEV_CAPTCHA_SITE_KEY}
// onChange={onVerify}
// />

export default Contact
